<template>
    <div v-if="!hash_acesso_biblioteca" class="login-container">
        <div class="login-image">
            <img src="/public/Logo-Branco.png" alt="Login Image" />
        </div>
        <div class="login-box">
            <h2>Login</h2>
            <p class="subtitle">Acesse com suas credenciais da plataforma do aluno.</p>
            <form @submit.prevent="handleLogin">
                <div class="form-group">
                    <label>Email</label>
                    <input v-model="email" type="email" required />
                </div>
                <div class="form-group">
                    <label>Senha</label>
                    <input v-model="password" type="password" required />
                </div>
                <button class="btn-login" type="submit">Entrar</button>
            </form>
        </div>
        <AlertModal v-if="showModal" :message="modalMessage" @close="handleModalClose" />
    </div>
    <div v-else>
        <div class="spinner-container">
            <div class="spinner"></div>
        
        </div>
    </div>
</template>

<script>
import '../styles/Login.css';
import request from '../router/request.js'
import AlertModal from '../components/AlertModal.vue';

export default {
    name: 'LoginView',
    components: { AlertModal },
    data() {
        return {
            email: '',
            password: '',
            showModal: false,
            modalMessage: '',
            isAuthenticated: false,
            hash_acesso_biblioteca: null
        };
    },
    methods: {
        handleModalClose() {
            this.showModal = false;
        },
        async checkAuth() {
            const token = localStorage.getItem('token');
            console.log(token)
            this.isAuthenticated = !!token && token !== '0';
            if (this.isAuthenticated) {
                this.$router.push('/library');
            }
        },
        handleLogin() {
            if (!this.email || !this.password) {
                this.modalMessage = 'Por favor, preencha todos os campos.';
                this.showModal = true;
                return;
            }
            request.post('/usuario/login', {
                username: this.email,
                password: this.password
            })
                .then(response => {
                    localStorage.setItem('token', response.data.token);
                    // this.modalMessage = 'Login bem-sucedido!';
                    // this.showModal = true;
                    this.isAuthenticated = true; // atualiza reatividade
                    this.$router.push('/library');
                })
                .catch(error => {
                    console.error('Erro ao fazer login:', error.response || error.message);
                    this.modalMessage = 'Login falhou. Verifique suas credenciais.';
                    this.showModal = true;
                });
        },
        handleUrlParams() {
            this.hash_acesso_biblioteca = this.$route.query.hash
            if (this.hash_acesso_biblioteca) {
                request.post('portal/ValidarAcessobiblioteca', {
                    hash_acesso_biblioteca: this.hash_acesso_biblioteca 
                })
                .then(response => {
                    console.log('resposta login: ', response.data);
                    localStorage.setItem('token', response.data.token);
                    this.modalMessage = 'Acesso biblioteca validado com sucesso!';
                    this.showModal = true;
                    this.isAuthenticated = true;
                })
                .catch(error => {
                    console.error('Erro ao validar hash de acesso biblioteca:', error);
                    this.hash_acesso_biblioteca = null;
                });
            }
        }
    },
    mounted() {
        this.checkAuth();
        this.handleUrlParams();

        this.authInterval = setInterval(() => {
            this.checkAuth();
        }, 60 * 1000);
    }
};
</script>
